import Vue from 'vue';
import App from './App.vue';
import store from './store';
import './assets/scss/app.scss';

Vue.config.productionTip = false;
Vue.filter('currency', (value, decimalPlaces) => `$${(+value).toFixed(decimalPlaces || 0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`);

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#app');
